import { withForm } from '@stern-ui/ui';
import { useStore } from '@tanstack/react-form';

import { isUs } from '@/globalConsts';
import { genderOptions, legalSexOptions, statusOptions } from '@/utils/filterOptions';

import { PatientIdValidation } from '../../PatientIdValidation';

import { patientListFiltersFormOptions } from './patientListFiltersFormOptions';
import { PatientListFiltersFormSection } from './PatientListFiltersFormSection';

export const PatientListFiltersPatient = withForm({
	...patientListFiltersFormOptions,
	render: function Render({ form }) {
		const ageMin = 0;
		const ageMax = 120;
		const studyId = useStore(form.store, (state) => state.values.study_id);
		const statusDisabled = (studyId || []).length !== 1;

		return (
			<PatientListFiltersFormSection title='Patient' dataTestId='filters-patient-section'>
				<div className='pt-2 pb-5'>
					<div className='grid grid-cols md:grid-cols-3 gap-4 md:gap-x-8 md:gap-y-4'>
						<form.AppField name='age'>
							{(field) => (
								<field.RangeSliderField
									label='Age'
									labelContainerClassName='flex flex-row justify-between items-center'
									additionalInfo={`Between ${ageMin} - ${ageMax}`}
									min={ageMin}
									max={ageMax}
									surfaceError={true}
								/>
							)}
						</form.AppField>
						<form.AppField name='gender'>
							{(field) => (
								<field.SelectField
									label='Gender ID'
									options={genderOptions}
									isMulti={true}
								/>
							)}
						</form.AppField>
						<form.AppField name='legal_sex'>
							{(field) => (
								<field.SelectField
									label='Legal Sex'
									options={legalSexOptions}
									isMulti={true}
								/>
							)}
						</form.AppField>
						<form.AppField name='status'>
							{(field) => (
								<field.SelectField
									label='Status'
									options={statusOptions}
									isMulti={true}
									isDisabled={statusDisabled}
									disabledHelpText='Select a single study to use'
								/>
							)}
						</form.AppField>
						<form.AppField name='needs_assistance'>
							{(field) => (
								<field.RadioField
									groupLabel='Needs assistance?'
									className='col6'
									dataTestId='needs-assistance-group'
									options={[
										{ label: 'All', value: '' },
										{ label: 'Yes', value: 'true' },
										{ label: 'No', value: 'false' },
									]}
								/>
							)}
						</form.AppField>
						{!isUs && (
							<form.AppField name='has_exclusion_code'>
								{(field) => (
									<field.RadioField
										groupLabel='Has exclusion code?'
										className='col6'
										dataTestId='has-exclusion-code-group'
										options={[
											{ label: 'All', value: '' },
											{ label: 'Yes', value: 'true' },
											{ label: 'No', value: 'false' },
										]}
									/>
								)}
							</form.AppField>
						)}
					</div>
					<div className='md:col-span-6 pt-8'>
						<form.AppField name='patient_ids_include'>
							{(field) => (
								<PatientIdValidation
									name={field.name}
									label='Include patients with uMed IDs'
									value={field.state.value || []}
									onValueChange={field.handleChange}
									fieldStateMeta={field.state.meta}
									dataTestId='patient-ids-include'
								/>
							)}
						</form.AppField>
					</div>
					<div className='md:col-span-6 pt-8'>
						<form.AppField name='patient_ids_exclude'>
							{(field) => (
								<PatientIdValidation
									name={field.name}
									label='Exclude patients with uMed IDs'
									value={field.state.value || []}
									onValueChange={field.handleChange}
									fieldStateMeta={field.state.meta}
									dataTestId='patient-ids-exclude'
								/>
							)}
						</form.AppField>
					</div>
				</div>
			</PatientListFiltersFormSection>
		);
	},
});
